import React, { useState, ChangeEvent, FormEvent, useRef, useEffect } from 'react';
import { IQuestion, IQuetionFrequency, IQuetionType, IQuestionOption } from '../../interfaces/Question';
import { text } from 'stream/consumers';
import { questionFrequencies, questionTypes } from '../../constants/Questions';
import DatePicker, {DateObject} from "react-multi-date-picker";
import moment from "moment";

interface PopupContentProps {
  closePopup: () => void;
  questionToEdit: IQuestion | null;
  updateQuestions: (question: IQuestion | null) => void;
}

const QuestionAddPopup: React.FC<PopupContentProps> = ({closePopup, updateQuestions, questionToEdit}) => {
  const [question, setQuestion] = useState<IQuestion | null>({...questionToEdit, text: questionToEdit?.text || ''})
  const questionOptions = questionToEdit?.options || Array<IQuestionOption>
  const [options, setOptions] = useState<IQuestionOption[] | []>(questionOptions)
  const [inputOption, setInputOption] = useState<string>('')

  const handleQuestionTypeChange = (e: ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault()
    setOptions([])
    setQuestion((prevQuestion) =>{
      return {
        ...prevQuestion,
        type: e.target.value as IQuetionType
      }
    })
  }

  const handleQuestionFrequencyChange = (e: ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault()
    setQuestion((prevQuestion) =>{
      return {
        ...prevQuestion,
        frequency: e.target.value as IQuetionFrequency
      }
    })
  }

  const handleOptionInputChange = (e:any) => {
    setInputOption(e.target.value);
  };

  const handleAddOption = () => {
    if (inputOption) {
      setOptions((prevOptions) =>{
        const index = prevOptions.length; // Calculate the index based on the length of prevOptions

        return [...prevOptions, {title: inputOption, score: index + 1}]

      })
      setInputOption('');
    }
  };

  const handleRemoveOption = (index:number) => {
    const updatedOptions = [...options];
    updatedOptions.splice(index, 1);
    setOptions(updatedOptions);
  };

  const handleDateChange = (dateToChange: DateObject | DateObject[] | null) => {
    setQuestion((prevQuestion) =>{
      return {
        ...prevQuestion,
        startDate : moment(dateToChange?.toString()).toDate(),
      }
    })
  }

  const handleEndDateChange = (dateToChange: DateObject | DateObject[] | null) => {
    setQuestion((prevQuestion) =>{
      return {
        ...prevQuestion,
        endDate : moment(dateToChange?.toString()).toDate(),
      }
    })
  }

  const handleSubmit = () => {
    if (question && !question.startDate) {
      question.startDate = new Date();
    }
    updateQuestions({...question, options})
  }

  return (
    <div className="popup-overlay relative z-[100]">
      <div className="relative bg-white px-2 md:px-8 w-80 md:w-[32rem] rounded-lg text-left">
        <button onClick={closePopup} className="close-btn">
          &times;
        </button>
        <div className="max-w-md mt-2 m-auto p-4 pb-4 md:p-8 bg-white rounded max-h-[80vh] overflow-y-auto scrollbar-hide ">
          <h2 className="text-xl md:text-2xl flex font-gilroy mb-6 font-bold  text-[#263238]">

            <img src='./images/round_icon.png' alt="condition" className='object-contain pr-2'/>
            { questionToEdit === null ? 'Add New Question' : 'Edit Question' }
          </h2>

          <form onSubmit={handleSubmit}>
            <div className="mb-6 mt-4">
              <label className="block text-[#607D8B] text-sm mb-2  font-gilroy" htmlFor="questionType">Question Type </label>
              <select id='questionType' className="w-full text-[#8D98AA] font-gilroy px-3 py-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-800 bg-[#F5F7F8]" onChange={handleQuestionTypeChange} required defaultValue={question?.type as string}>
                <option value="">Please select a question type</option>
                {
                  questionTypes.map((questionType, index) => {
                    return (
                      <option key={index} value={questionType}>{questionType}</option>
                    );
                  })
                }
              </select>
            </div>

            <div className="mb-6 mt-4">
              <label className="block text-[#607D8B] text-sm mb-2  font-gilroy" htmlFor="title">Question </label>
              <input type="text" id="question" name="question" className="w-full text-[#8D98AA] font-gilroy px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-gray-800 bg-[#F5F7F8]" placeholder="Please write your question" onChange={(e) => {
                setQuestion((prevState: IQuestion | null) => {
                  return {
                    ...prevState,
                    text: e.target.value
                  }
                })
              }} value={question?.text as string} required />
            </div>
            <div className="mb-6 mt-4">
              <label className="block text-[#607D8B] text-sm mb-2  font-gilroy" htmlFor="title">Legend </label>
              <input type="text" id="legend" name="legend" className="w-full text-[#8D98AA] font-gilroy px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-gray-800 bg-[#F5F7F8]" placeholder="Please write your question" onChange={(e) => {
                setQuestion((prevState: IQuestion | null) => {
                  return {
                    ...prevState,
                    legend: e.target.value
                  }
                })
              }} value={question?.legend as string} required />
            </div>

            <div className="mb-6 mt-4">
              <label className="block text-[#607D8B] text-sm mb-2  font-gilroy" htmlFor="questionFrequency">How often do you conduct question </label>
              <select id='questionFrequency' className="w-full text-[#8D98AA] font-gilroy px-3 py-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-800 bg-[#F5F7F8]" onChange={handleQuestionFrequencyChange} required defaultValue={question?.frequency as string}>
                <option value="">Please select a question type</option>
                {
                  questionFrequencies.map((questionFrequency, index) => {
                    return (
                      <option key={index} value={questionFrequency}>{questionFrequency}</option>
                    );
                  })
                }
              </select>
            </div>
            {
              (question?.type?.toUpperCase() === 'MULTICHOICE') && (
                <>
                  <label className="block text-[#607D8B] text-sm mb-2  font-gilroy" htmlFor="questionFrequency">Question Options </label>
                  <div className='mb-6 flex justify-center items-center gap-6'>
                    <input className={`w-full border text-[#657F8B] bg-gray font-[18px] border-gray-300 rounded-md focus:outline-none focus:border-gray-800 bg-[#F5F7F8] px-3 py-2`}  type="text" name="options" placeholder='' id="options" value={inputOption} onChange={(e)=>handleOptionInputChange(e)} required={ options.length === 0 }/>
                    <button type='button' onClick={()=>handleAddOption()} className='bg-[#F5F7F8] cursor-pointer text-[#8C97AC] border-[#E7EFF3] border-2 rounded-full py-2 px-4 inline-block font-gilroy focus:outline-none focus:border-gray-500'>+</button>
                  </div>
                  <div className='my-6 gap-6 flex flex-wrap items-center'>
                    {options?.map((option, index) => (
                        <div key={index} className='relative inline-block mb-4'>
                          <span className="font-gilroy bg-[#F5F7F8] text-[#657F8B] font-medium me-2 px-6 border border-[#E7EFF3] py-3 rounded-full border-1 "><span className='text-[#B4804A] font-semibold'>{(index < 9)? "0"+(index + 1) : index + 1}. </span>{option.title}</span>
                          <span className="absolute cursor-pointer bg-white inline-flex items-center justify-center w-7 h-7 text-2xl pt-1 font-normal text-[#83969F]  border-[#83969F] border-[1px] rounded-full -top-4 end-0  hover:border-gray-800" onClick={() => handleRemoveOption(index)}> &times;</span>
                        </div>
                    ))}
                  </div>
                </>
              )
            }
            <div className="mb-6 mt-4">
              <label
                  className="block text-[#607D8B] text-sm mb-2  font-gilroy"
              >
                Start Date
              </label>
              <DatePicker
                  placeholder="mm/dd/yyyy"
                  inputClass="border-2 text-[#263238] bg-[#EDF2F6] placeholder:text-[#8D98AA] font-[18px] focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] px-3 py-2 focus:outline-none focus:border-gray-500 w-full"
                  containerClassName="w-full"
                  calendarPosition="bottom"
                  required

                  onChange={(date) => handleDateChange(date)}
                  format="MM/DD/YYYY"
                  value={moment(question?.startDate).format("MM/DD/YYYY")}

              />
            </div>
            <div className="mb-6 mt-4">
              <label
                  className="block text-[#607D8B] text-sm mb-2  font-gilroy"
              >
                End Date
              </label>
              <DatePicker
                  placeholder="mm/dd/yyyy"
                  inputClass="border-2 text-[#263238] bg-[#EDF2F6] placeholder:text-[#8D98AA] font-[18px] focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] px-3 py-2 focus:outline-none focus:border-gray-500 w-full"
                  containerClassName="w-full"
                  calendarPosition="bottom"

                  onChange={(date) => handleEndDateChange(date)}
                  format="MM/DD/YYYY"
                  value={question?.endDate ? moment(question?.endDate).format("MM/DD/YYYY") : ""}

              />
              <p className="text-xs text-[#8D98AA] mt-1">Optional. The question will not be asked to participants after this date.</p>
            </div>
            <button type="submit" className="bg-[#B4804A] font-gilroy w-full text-white py-2 px-4 font-semibold rounded-md focus:outline-none border-[#E7EFF3] border-2 focus:border-gray-500">{ questionToEdit === null ? 'Add New Question' : 'Edit Question' }</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default QuestionAddPopup;
